import { useState } from "react";
import { FAQS } from "@/mocks/news";
import JsonLd from "./JsonLd";

export default function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: FAQS.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };

  return (
    <section id="faq" className="w-full bg-background-50 py-12 md:py-16">
      <JsonLd data={faqSchema} />
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-[1fr_1.6fr]">
          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-primary-600">
              FAQ
            </p>
            <h3 className="font-heading mt-2 text-2xl font-bold text-foreground-950 md:text-3xl">
              常见问题
            </h3>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              关于投稿、审核、回复与隐私保护，这里整理了大家最常问的问题。如仍有疑问，欢迎通过底部表单联系编辑部。
            </p>
          </div>

          <div className="space-y-3">
            {FAQS.map((f, idx) => {
              const open = openIndex === idx;
              return (
                <div
                  key={f.q}
                  className={`rounded-lg border bg-background-50 transition-colors ${
                    open ? "border-primary-200" : "border-background-200"
                  }`}
                >
                  <button
                    type="button"
                    className="flex w-full items-center justify-between gap-4 p-4 text-left md:p-5"
                    onClick={() => setOpenIndex(open ? null : idx)}
                    aria-expanded={open}
                  >
                    <span className="font-heading text-[15px] font-bold text-foreground-950 md:text-base">
                      {f.q}
                    </span>
                    <span
                      className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-colors ${
                        open
                          ? "bg-primary-500 text-background-50"
                          : "bg-secondary-100 text-foreground-600"
                      }`}
                    >
                      <i className={open ? "ri-subtract-line" : "ri-add-line"}></i>
                    </span>
                  </button>
                  {open && (
                    <p className="px-4 pb-4 text-sm leading-relaxed text-foreground-700 md:px-5 md:pb-5">
                      {f.a}
                    </p>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}